import { Link } from 'react-router-dom';
import { comics } from '@/mocks/comics';
import ComicCard from '@/components/feature/ComicCard';

export default function PopularSection() {
  const popularComics = [...comics]
    .sort((a, b) => b.views - a.views)
    .slice(0, 8);

  return (
    <section className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
      <div className="flex items-center justify-between mb-8">
        <div>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-2">
            热门排行
          </h2>
          <p className="text-sm text-foreground-500">大家都在看的精彩韩漫，人气爆棚</p>
        </div>
        <Link
          to="/category/all"
          className="flex items-center gap-1 text-sm font-medium text-primary-500 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
        >
          查看全部
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4 md:gap-6">
        {popularComics.map((comic, index) => (
          <div key={comic.id} className="relative">
            {index < 3 && (
              <div className="absolute -top-2 -left-2 z-10 w-7 h-7 flex items-center justify-center rounded-full bg-accent-500 text-background-50 text-xs font-bold">
                {index + 1}
              </div>
            )}
            <ComicCard comic={comic} />
          </div>
        ))}
      </div>
    </section>
  );
}